import { Package, Weight, Box, Anchor, FileText, LayoutList, Hash, BoxSelect } from "lucide-react";

interface ShipmentDetailsProps {
  shipment: any;
}

export const ShipmentDetails = ({ shipment }: ShipmentDetailsProps) => {
  const details = [
    { label: "Cargo Type", value: shipment.cargo_type || "General Goods", icon: <Package size={20} className="text-blue-600" /> },
    { label: "Weight", value: `${shipment.weight} kg`, icon: <Weight size={20} className="text-blue-600" /> },
    { label: "Container Type", value: shipment.container_type || "N/A", icon: <Box size={20} className="text-blue-600" /> },
    { label: "Shipping Mode", value: shipment.shipping_mode || shipment.service_type, icon: <Anchor size={20} className="text-blue-600" /> },
    { label: "Incoterm", value: shipment.incoterm || "CIF", icon: <FileText size={20} className="text-blue-600" /> },
    { label: "NO. of Units/Pieces", value: `${shipment.pieces} Units/Pieces`, icon: <BoxSelect size={20} className="text-blue-600" /> },
    { label: "Commodity", value: shipment.commodity || "N/A", icon: <LayoutList size={20} className="text-blue-600" /> },
    { label: "Reference No.", value: shipment.reference_number || "N/A", icon: <Hash size={20} className="text-blue-600" /> },
  ];

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-5 h-full">
      <h2 className="text-xs font-bold text-slate-800 tracking-wide uppercase mb-4">Shipment Details</h2>
      
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-y-5 gap-x-6">
        {details.map((detail, index) => (
          <div key={index} className="flex items-start gap-2.5">
            <div className="mt-0.5 bg-blue-50 p-1.5 rounded-md">
              {detail.icon}
            </div>
            <div>
              <p className="text-[10px] text-gray-500 uppercase tracking-wider font-semibold mb-0.5">{detail.label}</p>
              <p className="font-bold text-gray-900 text-sm">{detail.value}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
